export enum ExpressionOperatorEnum {
  AND = 'AND',
  OR = 'OR',
  NONE = 'NONE',
}
